export enum ErrorCode {
  EMPLOYEE_WITH_FK_NUMBER_NOT_EXISTS = "EMPLOYEE_WITH_FK_NUMBER_NOT_EXISTS",
  EMPLOYEE_WITH_GIVEN_UNIQUE_IDENTIFIER_NOT_EXISTS = "EMPLOYEE_WITH_GIVEN_UNIQUE_IDENTIFIER_NOT_EXISTS",
  EMPLOYEE_PERSONAL_DATA_MISMATCH = "EMPLOYEE_PERSONAL_DATA_MISMATCH",
  MISSING_ACTIVE_STATUS = "MISSING_ACTIVE_STATUS",
  REQUESTER_NOT_ENTITLED = "REQUESTER_NOT_ENTITLED",
  UNKNOWN = "UNKNOWN",
  MISSING_FK_NUMBER = "MISSING_FK_NUMBER",
  MISSING_FIRST_NAME = "MISSING_FIRST_NAME",
  MISSING_LAST_NAME = "MISSING_LAST_NAME",
  INVALID_YEAR = "INVALID_YEAR",
  MISSING_ABSENCE_TYPE = "MISSING_ABSENCE_TYPE",
  INVALID_PERIOD = "INVALID_PERIOD",
  EMPLOYEE_NOT_ASSIGNED_TO_ABSENCE_TYPE = "EMPLOYEE_NOT_ASSIGNED_TO_ABSENCE_TYPE",
  ABSENCE_TYPE_NOT_EXISTS = "ABSENCE_TYPE_NOT_EXISTS",
  ABSENCE_TYPE_NOT_SUPPORTED = "ABSENCE_TYPE_NOT_SUPPORTED",
  AVAILABLE_ABSENCE_PATTERN_NOT_EXISTS = "AVAILABLE_ABSENCE_PATTERN_NOT_EXISTS",
  NOT_ENOUGH_AVAILABLE_TIME_AMOUNT = "NOT_ENOUGH_AVAILABLE_TIME_AMOUNT",
  EMPLOYEE_HAS_ALREADY_ABSENCE_REQUESTS = "EMPLOYEE_HAS_ALREADY_ABSENCE_REQUESTS",
  EMPLOYEE_NOT_ASSIGNED_TO_AVAILABLE_ABSENCE_PATTERN = "EMPLOYEE_NOT_ASSIGNED_TO_AVAILABLE_ABSENCE_PATTERN",
  DUPLICATED_FK_NUMBER_ABSENCE_TYPE_NAME_CONFIGURATION = "DUPLICATED_FK_NUMBER_ABSENCE_TYPE_NAME_CONFIGURATION",
  INVALID_CURRENT_PATTERN_NAME = "INVALID_CURRENT_PATTERN_NAME",
  INVALID_NEW_PATTERN_NAME = "INVALID_NEW_PATTERN_NAME",
  INVALID_AVAILABLE_DAYS = "INVALID_AVAILABLE_DAYS",
  INVALID_TIME_AMOUNT_CHANGE = "INVALID_TIME_AMOUNT_CHANGE",
  EMPLOYEE_NOT_ASSIGNED_TO_CALENDAR = "EMPLOYEE_NOT_ASSIGNED_TO_CALENDAR",
  CALENDAR_NOT_EXISTS = "CALENDAR_NOT_EXISTS",
  DUPLICATED_FK_NUMBER_AND_YEAR_CONFIGURATION = "DUPLICATED_FK_NUMBER_AND_YEAR_CONFIGURATION",
  CALENDAR_INACTIVE = "CALENDAR_INACTIVE",
  MISSING_EMPLOYEE_IDENTIFIER = "MISSING_EMPLOYEE_IDENTIFIER",
  INVALID_CREATION_TIME = "INVALID_CREATION_TIME",
  MISSING_START_DATE = "MISSING_START_DATE",
  INVALID_START_DATE_FORMAT = "INVALID_START_DATE_FORMAT",
  MISSING_END_DATE = "MISSING_END_DATE",
  INVALID_END_DATE_FORMAT = "INVALID_END_DATE_FORMAT",
  MISSING_STATUS = "MISSING_STATUS",
  INVALID_START_TIME = "INVALID_START_TIME",
  INVALID_END_TIME = "INVALID_END_TIME",
  INVALID_STATUS = "INVALID_STATUS",
  APPROVER_WITH_GIVEN_UNIQUE_IDENTIFIER_NOT_EXISTS = "APPROVER_WITH_GIVEN_UNIQUE_IDENTIFIER_NOT_EXISTS",
  ABSENCE_REQUEST_INVALID_TIME_RANGE = "ABSENCE_REQUEST_INVALID_TIME_RANGE",
  ABSENCE_REQUEST_INVALID_DATE_RANGE = "ABSENCE_REQUEST_INVALID_DATE_RANGE",
  ABSENCE_REQUEST_EMPLOYEE_MISSING_CALENDAR = "ABSENCE_REQUEST_EMPLOYEE_MISSING_CALENDAR",
  ABSENCE_REQUEST_ABSENCE_TIME_NOT_COMPATIBLE = "ABSENCE_REQUEST_ABSENCE_TIME_NOT_COMPATIBLE",
  ABSENCE_REQUEST_IMPORTED_TOO_OLD = "ABSENCE_REQUEST_IMPORTED_TOO_OLD",
  BILLING_CYCLE_TOO_OLD = "BILLING_CYCLE_TOO_OLD",
  FUTURE_CREATION_TIME = "FUTURE_CREATION_TIME",
}

export default (errorCode: ErrorCode): string => {
  const errorMessages: Record<ErrorCode, string> = {
    EMPLOYEE_WITH_FK_NUMBER_NOT_EXISTS:
      "Nieprawidłowy identyfikator pracownika, zweryfikuj dane.",
    EMPLOYEE_WITH_GIVEN_UNIQUE_IDENTIFIER_NOT_EXISTS:
      "Nieprawidłowy identyfikator, zweryfikuj dane.",
    EMPLOYEE_PERSONAL_DATA_MISMATCH:
      "Dane w kolumnach imię, nazwisko, MPK, forma zatrudnienia lub status zostały zmienione. Przywróć ich oryginalne wartości.",
    MISSING_ACTIVE_STATUS: "Uzupełnij dane.",
    REQUESTER_NOT_ENTITLED: "Import niemożliwy, brak uprawnień.",
    UNKNOWN: "Import niemożliwy, nieznany błąd.",
    MISSING_FK_NUMBER: "Uzupełnij dane.",
    MISSING_FIRST_NAME: "Uzupełnij dane.",
    MISSING_LAST_NAME: "Uzupełnij dane.",
    INVALID_YEAR: "Nieprawidłowa wartość, zweryfikuj dane.",
    MISSING_ABSENCE_TYPE: "Uzupełnij dane.",
    INVALID_PERIOD: "Nieprawidłowy okres rozliczeniowy, zweryfikuj dane.",
    EMPLOYEE_NOT_ASSIGNED_TO_ABSENCE_TYPE:
      "Pracownik nie uprawniony do złożenia wskazanego typu wniosku.",
    ABSENCE_TYPE_NOT_EXISTS: "Szablon wniosku nie istnieje.",
    ABSENCE_TYPE_NOT_SUPPORTED:
      "Dane nie mogą zostać wprowadzone, sprawdź ustawienia szablonu wniosku.",
    AVAILABLE_ABSENCE_PATTERN_NOT_EXISTS:
      "Wprowadzony wzorzec nie istnieje, zweryfikuj wzorce.",
    NOT_ENOUGH_AVAILABLE_TIME_AMOUNT:
      "Bilans dni pracownika po zmianach nie może być ujemny.",
    EMPLOYEE_HAS_ALREADY_ABSENCE_REQUESTS:
      "Zmiana wzorca niemożliwa, pracownik posiada złożone wnioski na przyszłe okresy rozliczeniowe.",
    EMPLOYEE_NOT_ASSIGNED_TO_AVAILABLE_ABSENCE_PATTERN:
      "Pracownik nie jest przypisany do dostępnych wzorców.",
    DUPLICATED_FK_NUMBER_ABSENCE_TYPE_NAME_CONFIGURATION:
      "Zduplikowany wiersz dla pracownika i rodzaju nieobecności.",
    INVALID_CURRENT_PATTERN_NAME: "Niepoprawny wzorzec, zweryfikuj dane.",
    INVALID_NEW_PATTERN_NAME: "Niepoprawny wzorzec, zweryfikuj dane.",
    INVALID_AVAILABLE_DAYS: "Niepoprawny wymiar, zweryfikuj dane.",
    INVALID_TIME_AMOUNT_CHANGE: "Niepoprawny wymiar, zweryfikuj dane.",
    EMPLOYEE_NOT_ASSIGNED_TO_CALENDAR:
      "Pracownik nie jest przypisany do kalendarza, zweryfikuj dane.",
    CALENDAR_NOT_EXISTS: "Kalendarz nie istnieje.",
    DUPLICATED_FK_NUMBER_AND_YEAR_CONFIGURATION:
      "Zduplikowany wiersz dla pracownika i roku.",
    CALENDAR_INACTIVE: "Kalendarz nieaktywny.",
    MISSING_EMPLOYEE_IDENTIFIER:
      "Nieprawidłowy identyfikator pracownika, zweryfikuj dane.",
    INVALID_CREATION_TIME:
      "Nieprawidłowa wartość, zweryfikuj dane i wprowadź je w formacie zgodnym z instrukcją.",
    MISSING_START_DATE: "Uzupełnij dane.",
    INVALID_START_DATE_FORMAT:
      "Nieprawidłowa wartość, zweryfikuj dane i wprowadź je w formacie zgodnym z instrukcją.",
    MISSING_END_DATE: "Uzupełnij dane.",
    INVALID_END_DATE_FORMAT:
      "Nieprawidłowa wartość, zweryfikuj dane i wprowadź je w formacie zgodnym z instrukcją.",
    MISSING_STATUS: "Uzupełnij dane.",
    INVALID_START_TIME:
      "Nieprawidłowa wartość, zweryfikuj dane i wprowadź je w formacie zgodnym z instrukcją.",
    INVALID_END_TIME:
      "Nieprawidłowa wartość, zweryfikuj dane i wprowadź je w formacie zgodnym z instrukcją.",
    INVALID_STATUS:
      "Niepoprawny status, zweryfikuj dane i wprowadź je w formacie zgodnym z instrukcją.",
    APPROVER_WITH_GIVEN_UNIQUE_IDENTIFIER_NOT_EXISTS:
      "Nieprawidłowy identyfikator pracownika, zweryfikuj dane.",
    ABSENCE_REQUEST_INVALID_TIME_RANGE:
      "Sprawdź kompletność i poprawność danych.",
    ABSENCE_REQUEST_INVALID_DATE_RANGE: "Sprawdź zakres dat.",
    ABSENCE_REQUEST_EMPLOYEE_MISSING_CALENDAR:
      "Pracownik nie posiada kalendarza, uzupełnij dane.",
    ABSENCE_REQUEST_ABSENCE_TIME_NOT_COMPATIBLE:
      "Niekompatybilny typ wniosku, sprawdź ustawienia.",
    ABSENCE_REQUEST_IMPORTED_TOO_OLD:
      "Edycja niemożliwa, wniosek można edytować jedynie w roku bieżącym lub poprzednim.",
    BILLING_CYCLE_TOO_OLD:
      "Edycja niemożliwa, wniosek można edytować jedynie w roku bieżącym lub poprzednim.",
    FUTURE_CREATION_TIME:
      "Import niemożliwy - nieprawidłowa data złożenia wniosku (data przyszła). Zweryfikuj dane.",
  };

  return errorMessages[errorCode] || "Wystąpił nieznany błąd.";
};
